<template>
<div>
  <div class="body">

    <v-alert v-if="alertType" :type="alertType" :value="true" outlined>
      <span v-html="message"></span>
    </v-alert>

    <v-banner v-if="isCliente" style="color:white; font-size:18px; font-weight:600;" :color="scdOrange" sticky slot="icon">
      <div class="d-flex align-center justify-space-between">
        <div class="d-flex align-center">
          <v-icon class="mr-9" icon="mdi-alert-outline" color="white" size="40">mdi-alert-outline</v-icon>
          <div class="mr-9" style="line-height:1.3;">
            <div class="mb-2">Hai terminato le simulazioni disponibili !</div>
            <div>Per continuare ad allenarti, acquista una ricarica: con pochi click, le nuove simulazioni saranno immediatamente a tua disposizione.</div>
          </div>
        </div>
        <v-btn @click="apriDialogAcquistoRicariche()" class="mr-7" style="color:white; border-radius:0;" depressed color="green">Ricarica le simulazioni</v-btn>
      </div>
    </v-banner>

    <v-banner v-else-if="isCliccatore" style="color:white; font-size:18px; font-weight:600;" :color="scdOrange" sticky slot="icon">
      <div class="d-flex align-center">
        <v-icon class="mr-9" icon="mdi-alert-outline" color="white" size="40">mdi-alert-outline</v-icon>
        <div class="mr-9">
          <div>Hai terminato le simulazioni disponibili: contatta il tuo amministratore per richiederne altre e continuare ad allenarti.</div>
        </div>
      </div>
    </v-banner>

    <v-banner v-else-if="isProvaGratuita" style="color:white; font-size:18px; font-weight:600;" :color="scdOrange" sticky slot="icon">
      <div class="d-flex align-center justify-space-between">
        <div class="d-flex align-center">
          <v-icon class="mr-9" icon="mdi-alert-outline" color="white" size="40">mdi-alert-outline</v-icon>
          <div class="mr-9" style="lineheight:1.2;">
            <div class="mb-2">Hai terminato le simulazioni disponibili !</div>
            <div>Acquista uno dei nostri pacchetti per iniziare ad allenarti sul serio, ti bastano pochi click.</div>
          </div>
        </div>
        <v-btn @click="apriPaginaPacchetti()" class="mr-7" style="color:white; border-radius:0;" depressed color="green">Acquista un pacchetto</v-btn>
      </div>
    </v-banner>

    <header>
      <!-- <h1>INAIL - Istituto Nazionale per l'Assicurazione contro gli Infortuni sul Lavoro</h1> -->
      <!-- <a id="logo-inail" href="https://bandoisi.inailcloud.it/html/dummy.html#" title="torna alla homepage INAIL"> -->

      <!-- <div :style="`background-color:${scdOrange}; height:400px;`">

      </div> -->

      <div class="d-flex justify-space-between">
        <a id="logo-inail" href="#">
          <img src="https://app.simulatoreclickday.it/img/LogoInail.png">
        </a>

        <!-- <v-btn data-tour-step-simulazioni="11" depressed :color="scdOrange" class="_semi_bold white--text px-12 btn dati-personali" @click="computedClienteClickdayIt ? popUpDatiCliccatore() : showDatiCliccatore()" style="text-transform:none; letter-spacing:0.5px; height:50px;">
          Apri Finestra Dati Personali
        </v-btn> -->

        <div>
          <input
	          @click="computedClienteClickdayIt ? popUpDatiCliccatore() : showDatiCliccatore()"
	          type="button"
	          value="Apri Finestra Dati Personali"
	          class="btn dati-personali"
          >
        </div>

        <div class="width: 212px">
          <!--<input @click="isSimulazioneGuidata || simulazioniTerminate ? goBack() : abbandona()" :disabled="isLeftingSimulazione" type="button" :value="`${ simulazioniTerminate ? 'Torna alla Home' : 'Abbandona simulazione'}`" class="btn abbandona simulazione-step-8">-->
        </div>
      </div>
      
    </header>

    <div class="main">
      <div style="padding-left:5px" class="simulazione-step-2">

        <template v-if="status == 'not_started'">
          <h2>
            Non è ancora possibile eseguire l'invio.
          </h2>
          
          <div class="m-4 font-weight-bold" style="font-size:16px; width: auto;">
            <!-- <div style="color:#002e5f;">La simulazione inizierà alle ore <span data-tour-step="1">{{getTimeByDatetime(simulazione.data_ora)}}</span></div> -->
            <div style="color:#002e5f;">La simulazione inizierà alle ore <span class="pa-1 simulazione-step-1">{{ orarioSimulazione }}</span></div>
            <div v-if="!computedClienteClickdayIt" class="error--text" >
	            Aggiornare la pagina premendo ripetutamente F5 su Windows o Mela+R su MAC
            </div>
            <div v-else-if="computedClienteClickdayIt" class="error--text" >
	            Aggiorna la pagina al secondo spaccato premendo F5 su Windows o CMD+R su Mac.<br>
	            Utilizza il sito <a href="https://time.is" target="_blank" :style="`color: ${scdOrange}; text-decoration: underline;`">TIME.IS</a> per conoscere l’orario esatto ed essere perfettamente sincronizzato.<br>
	            Non basarti sull’orario del tuo PC anche nel caso dovesse mostrare i secondi.
            </div>
          </div>
          
          <div :style="`color:${scdOrange}; font-size:16px;`" class="mt-6 font-weight-bold">I dati necessari per la simulazione sono nella finestra dei dati personali, clicca il pulsante arancione in alto per aprirla</div>
        </template>

        <template v-else-if="status == 'started'">

          <h2 style="line-height: 1.2">Finalizza la domanda presentata</h2>

          <div class="form-gray">
            <div style="margin-bottom:40px; font-size:16px; font-weight:600;">INSERIMENTO DATI</div>
            <!-- <form method="post" action="/risultato" @submit="continuaOppureInvia" autocomplete="off"> -->
						<!--style="margin-bottom: 40px"-->
						<v-form ref="formEseguiSimulazione">
              <input type="hidden" name="_token" :value="csrf">
              <!-- <input type="hidden" name="simulazione_id" :value="simulazione.id">
              <input type="hidden" name="bando_id" :value="bandoId">
              <input type="hidden" name="anno_mese_giorno_simulazione" :value="annoMeseGiornoSimulazione"> -->

              <fieldset id="form-fieldset">
                <div style="margin-bottom:15px; color:black">
									Per procedere con l'invio della domanda è necessario compilare i seguenti campi:
								</div>

                <div style="display:inline-block; width: 100%" class="simulazione-step-3 simulazione-step-5">

                  <domande-risposte-component
                    ref="domandeRisposteComponentRef"
                    :domandeConRisposte="domandeConRisposte"
                    :stato="status"
                    @aggiorna-risposte-utente="aggiornaRisposteUtente"
                    @aggiorna-schermata-attuale-e-massima="aggiornaSchermataAttualeEMassima"
                    @aggiorna-checkbox-bloccanti-schermata-attuale="aggiornaCheckboxBloccantiSchermataAttuale"
                  />
                  
                </div>
              </fieldset>
							
							<div class="d-flex justify-space-between mt-10">
								<div class="d-flex justify-start">
									<input
										@click="isSimulazioneGuidata || simulazioniTerminate ? goBack() : abbandona()"
										:disabled="isLeftingSimulazione"
										type="button"
										:value="`${ simulazioniTerminate ? 'Torna alla Home' : 'Esci'}`"
										class="btn simulazione-step-8"
									>
								</div>
								
								<div class="d-flex justify-end">
									<input
										v-if="schermataAttuale > 1"
										@click="setDomandeESchermataDaMostrare('indietro')"
										type="button"
										value="Indietro"
										title="Indietro"
										class="btn mr-5 simulazione-step-7"
										tabindex="3"
									>
									<input
										type="button"
										v-show="schermataAttuale < maxSchermate"
										@click="setDomandeESchermataDaMostrare('avanti')"
										:disabled="checkboxesBloccantiAttive"
										value="Continua"
										class="btn simulazione-step-4"
										tabindex="2"
									>
									<input
										type="button"
										v-show="schermataAttuale == maxSchermate"
										@click="inviaRisposte"
										:disabled="eseguitaSimulazioneConGuida || simulazioniTerminate || checkboxesBloccantiAttive"
										value="Invia"
										class="btn btn-green simulazione-step-6"
										tabindex="2"
									>
								</div>
							</div>
            </v-form>
            <!-- </form> -->
          </div>
					<!--<div>* Campo obbligatorio</div>-->

          <div v-if="eseguitaSimulazioneConGuida" class="page-overlay"></div>

          <!-- <v-row v-if="eseguitaSimulazioneConGuida" class="avviso-finale-prova"> -->
          <v-dialog persistent v-model="eseguitaSimulazioneConGuida" max-width="504px">
              <v-col class="pa-4 white--text" style="background-color:#002e5f">
                  <span class="title">
                    Complimenti, hai completato la guida! 
                  </span>
                    <br><br>
                  <span class="title">
                    Adesso clicca su OK per tornare alla Pagina Iniziale ed eseguire la tua prima vera simulazione!
                  </span>
                  <div class="ok-button-wrapper">
                    <a class="ok-button" href="/home">OK</a>
                  </div>
              </v-col>
          </v-dialog>

        </template>
          
        </div>
    </div>

    <footer>
			© 2024 INAIL - ISTITUTO NAZIONALE PER L'ASSICURAZIONE CONTRO GLI INFORTUNI SUL LAVORO - P. IVA 00968951004
      <!-- <div sm="11" style="text-align: right;">
        <span class="hidden-sm-and-down">
          Hai ancora dubbi sul funzionamento? Mostra di nuovo la <a @click="openGuide()" class="error--text"><b>GUIDA</b></a> oppure leggi le <a target="_blank" href="https://simulatoreclickday.it/#faq" class="error--text"><b>F.A.Q.</b></a>
        </span>
        <span class="hidden-md-and-up">
          <a @click="openGuide()" class="error--text"><b>GUIDA</b></a>
        </span>
      </div> -->
    </footer>

    <v-tour name="explanatoryTour" :steps="tourSteps" :options="tourOptions" :callbacks="tourCallbacks">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.currentStep === index"
            v-for="(step, index) of tour.steps"
            :key="index"
            :step="step"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
            style="max-width: 600px"
            :highlight="tour.highlight"
          >
          </v-step>
        </transition>
      </template>
    </v-tour>

    <v-dialog v-model="isDatiCliccatoreDialogOpen" width="920">
      <v-card min-width=900 max-width=900>
        <v-card-title class="headline">
          <!-- <span class="ml-4">DATI CLICCATORE</span> -->
          <v-spacer></v-spacer>
          <v-btn color="black--text" icon @click="isDatiCliccatoreDialogOpen = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div :style="`margin:0 10px 20px; color:${scdOrange}; font-weight:500;`">
            ATTENZIONE:<br>Questa finestra contiene i dati personali che possono essere richiesti durante le simulazioni. Devi quindi copiarli e incollarli in un blocco note per averli a portata di mano durante gli allenamenti.
          </div>
          <dati-cliccatore-component v-if="isDatiCliccatoreDialogOpen" :IdUtenteProp="computedIdUtente"/>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :color="scdColor" style="text-transform:none; padding:0 20px; color:white;" depressed rounded class="mr-4 mb-3" @click="isDatiCliccatoreDialogOpen = false">Chiudi</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ricariche-component :toggleDialog="isDialogAcquistoRicaricheAperta" @chiudiDialog="chiudiDialogAcquistoRicariche($event)"></ricariche-component>

  </div>
</div>
</template>

<script>
import mixin from '../../mixins';
import { uuid } from 'vue-uuid';

export default {
  data() {
    return {
      alertType: null,
      message: null,
      
      idCliccatore: this.computedIdUtente,

      isCliente: false,
      isProvaGratuita: false,
      isCliccatore: false,

      isLeftingSimulazione: false,

      status: null,

      schermataAttuale: 0,
      maxSchermate: 0,
      checkboxesBloccantiAttive: false, // nella schermata attuale

      simulazioniTerminate: false,

      bando: null,

      risposteUtente: {}, // Risposte terminali dell'utente (già controllate e passate dal componente figlio)
      
      tastoContinuaVisibile: true,
      tastoIndietroVisibile: false,
      tastoInviaVisibile: false,

      // Inserisco il Csrf Token presente nei META
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),

      // Tour guidato al primo accesso:
      eseguitaSimulazioneConGuida: false,

      tourSteps: [],
      tourOptions: {
          useKeyboardNavigation: false,
          labels: {
              buttonSkip: 'Salta guida',
              buttonPrevious: 'Precedente',
              buttonNext: 'Successivo',
              buttonStop: 'Fine'
          },
          highlight: true
      },
      tourCallbacks: {
        onPreviousStep: this.vaiAllaPaginaPrecedente,
        onNextStep: this.vaiAllaPaginaSuccessiva,
        onStop: this.utentePuoInteragire
      },
      currentStep: 2,
      tourInEsecuzione: false,

      ripetiGuida: false,

      isDatiCliccatoreDialogOpen: false,

      isDialogAcquistoRicaricheAperta: false,

      domandeConRisposte: [],
      
      simulazioneId: null,
      simulazioneDataOra: null,
      isSimulazioneGuidata: false,
    };
  },

  mounted() {
    this.getDatiSimulazione();
  },
	
	computed: {
		orarioSimulazione() {
			return moment(this.simulazioneDataOra/*this.datiSimulazione.dataOra*/, "YYYY-MM-DD hh:mm:ss").format('HH:mm:ss');
		},
		annoMeseGiornoSimulazione() {
			return moment(this.simulazioneDataOra/*this.datiSimulazione.dataOra*/, "YYYY-MM-DD hh:mm:ss").format('YYYY-MM-DD');
		},
	},

  methods: {
    getDatiSimulazione() {
      axios
      .get('/ottieniSimulazione')
      .then(response => {
        this.simulazioneId = response.data.simulazione.id;
        this.simulazioneDataOra = response.data.simulazione.dataOra;
        this.isSimulazioneGuidata = response.data.simulazione.simulazioneGuidata;
				
        // this.maxSchermate = response.data.simulazione.maxSchermate; // => Calcolato dinamicamente nel componente figlio
        this.status = response.data.status;
	      this.simulazioniTerminate = response.data.simulazione.simulazioniTerminate;
	      this.bando = response.data.bando;

				// le domande le ho ordinate per schermata usando un metodo di Laravel
        this.risposteUtente = {};
	      if (this.status == 'started') {
          // Le domande e risposte che arrivano dal BE sono senza shuffle:
          this.domandeConRisposte = response.data.simulazione.simulazione;
	      }
	      
	      this.startSimulazioneTour();
	      
	      if (this.simulazioniTerminate && !this.isSimulazioneGuidata) {
		      this.mostraBannerSimulazioniTerminate();
	      }
      })
    },

    aggiornaSchermataAttualeEMassima(schermataObj) {
      this.schermataAttuale = schermataObj.attuale;
      this.maxSchermate = schermataObj.massima;
    },

    aggiornaCheckboxBloccantiSchermataAttuale(isBloccante){
      this.checkboxesBloccantiAttive = isBloccante;
    },
    setDomandeESchermataDaMostrare(direzione) {
      if(direzione == 'avanti')
        this.$refs.domandeRisposteComponentRef.vaiAvanti();
      else if(direzione == 'indietro')
        this.$refs.domandeRisposteComponentRef.vaiIndietro();
    },
    tornaAllaPrimaSchermata() {
      this.$refs.domandeRisposteComponentRef.vaiASchermata(1);
    },
    goBack: function(){
      // Torna semplicemente indietro: disponibile quando sto visualizzando la guida
      window.location.href = "/home#/";
    },
    abbandona: function() {
      // Avviso il server di segnare la simulazione come abbandonata, e poi torno indietro
      this.isLeftingSimulazione = true;

      axios
        .get(`/simulazioni/${this.simulazioneId}/${this.bando.id}/${this.annoMeseGiornoSimulazione}/abbandona`)
        .then(response => {
          window.location.href = "/home#/";
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.isLeftingSimulazione = false;
        });
    },

    aggiornaRisposteUtente(nuoveRisposte) { // Chiamata dal componente figlio man mano che l'utente fornisce le risposte
      this.risposteUtente = nuoveRisposte;
    },

    inviaRisposte() {
      if (this.tourInEsecuzione) {
        return;
      }

      if (this.simulazioniTerminate) {
        this.setDomandeESchermataDaMostrare(direzione);
        return;
      }

      if (this.$refs.domandeRisposteComponentRef.controllaRisposte()) {
        // Se sono in modalità GUIDA, non proseguire a mostrare il risultato!
        if (this.isSimulazioneGuidata/* && inviaForm*/){
          this.eseguitaSimulazioneConGuida = true;
          this.$tours['explanatoryTour'].stop();
          return;
        }

        let formData = new FormData();
        formData.append('risposte', JSON.stringify(this.risposteUtente));
        formData.append('simulazione_id', this.simulazioneId);
        formData.append('bando_id', this.bando.id);
        formData.append('anno_mese_giorno_simulazione', this.annoMeseGiornoSimulazione);
        axios.post('/risultato',
          formData,       
          {
            headers: {
                'Content-Type': 'application/json'
            },
          }
        )
        .then(response => {
          let risultatoSimulazione = {
              bandoId: this.bando.id,
              provaGratuita: response.data.provaGratuita,
              countAltriUtenti: response.data.countAltriUtenti,
              minimoAltriUtenti: response.data.minimoAltriUtenti,
              tempoImpiegato: response.data.tempoImpiegato,
              colore: response.data.colore,
              hasError: response.data.hasError,
              message: response.data.message,
            } 

          localStorage.setItem('risultatoSimulazione', JSON.stringify(risultatoSimulazione));
	        
	        this.$router.push({
		        name: `risultato-${this.bando.route}`,
		        params: risultatoSimulazione
	        });
        })
      }
    },
    getTimeByDatetime: function(datetime) {
      return datetime.split(" ")[1];
    },
    openGuide() {
      this.ripetiGuida = true;
      if (this.tastoInviaVisibile) { // se il tasto invia è visibile vuol dire che sono nella seconda schermata e lo riporto nella prima
        this.toggleDomande();
      }
      this.startSimulazioneTour();
    },
    startSimulazioneTour() {
      if(this.isSimulazioneGuidata || this.ripetiGuida){ // Se il parametro "Guida" è nell'URL allora avvio la guida
        this.tourInEsecuzione = true;
        
        if(this.status == 'not_started'){
          this.tourSteps = [
            {
              target: '.simulazione-step-1',
              content: `Eccoci alla tua prima Simulazione!<br>Appena si avvicina l'orario indicato, aggiorna la pagina<br>(per farlo velocemente premi 'F5' su Windows o 'Mela+R' su MAC)`
            }
          ];
        } else { // Se la simulazione è partita e la Guida è richiesta mostro questo:
          this.tourSteps = [
              {
                target: '.simulazione-step-2',
                content: `La simulazione è divisa in più pagine, ogni pagina ti chiederà di compilare dei campi`,
                params: {
                  placement: 'top'
                }
              },
              {
                target: '.simulazione-step-3',
                content: `Questa è la prima serie di campi,<br>presta molta attenzione a cosa c'è scritto.`,
                params: {
                  placement: 'top'
                }
              },
              {
                target: '.simulazione-step-4',
                content: `Questo bottone ti permette di visualizzare la seconda pagina, 
                ma solamente se avrai compilato correttamente i campi in questa pagina.`,
                params: {
                  placement: 'left-end'
                }
              },
              {
                target: '.simulazione-step-5',
                content: `Ora siamo nella seconda pagina e questa è la seconda serie di campi`,
                params: {
                  placement: 'top'
                },
                // before: promise => new Promise((resolve, reject) => {
                //   // Time-consuming UI/async operation here
                //   let response = this.continuaOppureInvia(false, true);
                //   if (response == 'pagina successiva') {
                //     resolve(response);
                //   }
                // })
                // .then(() => {
                //   this.toggleDomande();
                //   console.log('then');
                // })
              },
              {
                target: '.simulazione-step-6',
                content: `Questo bottone ti permette di eseguire la simulazione, 
                sempre dopo aver correttamente compilato i campi`,
                params: {
                  placement: 'top-end'
                }
              },
              {
                target: '.simulazione-step-7',
                content: `Questo bottone ti permette di tornare alla pagina precedente`,
                params: {
                  placement: 'top-start'
                }
              },
              {
                target: '.simulazione-step-8',
                content: `Se vuoi abbandonare la simulazione usa questo bottone.<br><br>
                Ricorda che il giorno del vero Click Day non potrai tornare indietro se l’invio della domanda è difficile, avrai una sola chance. Per cui ti consigliamo di non abbandonare mai le simulazioni ma di allenarti a superarle tutte!<br><br>
                Ora tocca a te, cliccando su Fine tornerai alla prima pagina e potrai svolgere questa simulazione di prova!`,
                params: {
                  placement: 'left-start'
                }
              },
            ]     
        }

        setTimeout(() => {
          this.$tours['explanatoryTour'].start();
        }, 10);
      }
    },
    vaiAllaPaginaPrecedente() {
      this.currentStep--;
      if (this.currentStep == 4) {
        this.setDomandeESchermataDaMostrare('indietro');
      }
    },
    vaiAllaPaginaSuccessiva() {
      this.currentStep++;
      if (this.currentStep == 5) {
        this.setDomandeESchermataDaMostrare('avanti');
      }
    },
    utentePuoInteragire() {
      this.tourInEsecuzione = false;

      this.$nextTick(() => {
        try {
          this.$refs.domandeRisposteComponentRef.inizializzazioneDomandeRisposte(); // re-inizializzo le domande (e le schermate) nel parent  
        } catch (error) { // Se non va a buon fine poco male
          console.log("ABWS23") // Giusto per renderlo riconoscibile
        }
      });
    },

    mostraBannerSimulazioniTerminate() {
      if (window.__NOME_PACCHETTO__ == 'PROVAGRATUITA') {
        this.isProvaGratuita = true;
      } else if (window.__NOME_PACCHETTO__ != 'PROVAGRATUITA' && window.__RUOLO__ == 'Admin') {
        this.isCliente = true;
      } else if (window.__NOME_PACCHETTO__ != 'PROVAGRATUITA' && window.__RUOLO__ != 'Admin') {
        this.isCliccatore = true;
      }
    },
    apriPaginaPacchetti() {
      window.open('https://simulatoreclickday.it/acquista/');
    },
    apriDialogAcquistoRicariche() {
      this.isDialogAcquistoRicaricheAperta = true;
    },
    chiudiDialogAcquistoRicariche() {
      this.isDialogAcquistoRicaricheAperta = false;
    },
    showDatiCliccatore(idCliccatore) {
      this.idCliccatoreToShowDati = idCliccatore;
      this.isDatiCliccatoreDialogOpen = true;
    }
  }
};
</script>

<style lang="scss" scoped>
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap');

	* {
		font-family: 'Open Sans', sans-serif !important;
	}

	::v-deep {
		.v-input--checkbox label {
			color: black !important;
			font-size: 14px !important;
			font-family: 'Open Sans', sans-serif !important;
		}
	}

  .body {
    min-width: 489.1px;
    max-width: 1366px;
    width: auto;
    margin-right: auto;
    margin-left: auto;
    font-size: 14.4333px;
		background-color: white;
  }
  footer {
    //position: absolute;
    //bottom: 0;
    //left: 0;
    width: 100%;
    background-color: #002e5f;
    padding: 20px 60px 20px;
    color: #fff;
    font-size: .9em;
  }
  #logo-inail {
    margin-left: 60px;
    margin-bottom: 40px;
    display: block;
    width: 176px;
    height: 56px;
  }
  #logo-inail img {
    width: 176px;
  }
  h1 {
    display: none
  }
  h2 {
    margin-top: 0;
  }
  h3 {
    margin: 0;
    margin-bottom: 30px;
    text-transform: uppercase;
    font-weight: 400;
    font-size: 16.5px;
  }
  h4 {
    font-size: 1.25em;
    margin-top: 10px;
    margin-bottom: 25px;
    font-weight: 500;
    line-height: 1.1;
  }
  fieldset {
    margin: 0;
    padding: 0;
    border: 0;
  }
  p {
    margin-bottom: 10px;
  }
  header {
    padding-top: 48px;
    border-bottom: 20px solid #002e5f;
  }
  .main {
    border-top: 20px solid #1E6665;
    padding: 30px;
  }
  .main h2 {
    color: #002e5f;
    margin-bottom: 30px;
    font-family: 'Open Sans semibold', sans-serif;
    font-size: 23.8333px;
    font-weight: 500;
  }
  .mr-15 {
      margin-right: 15px;
  }
  .form-gray {
    background-color: #f2f2f2;
    padding: 35px 30px;
  }
  .form-elem {

    margin-bottom: 20px;
  }
  .form-elem .msg {
    position: relative;
    top: 5px;
    display: none;
  }
  .form-elem input:not([type="checkbox"]):not([type="radio"]),
  //.form-elem label,
  .form-elem select {
    width: 100%;
    border: 1px solid #afafaf;
    background-color: #fff;
    height: 34px;
    box-sizing: border-box;
    padding: 6px 12px;
  }
  .form-elem input:focus,
  .form-elem select:focus {
    outline: 0;
    border-color: #66afe9;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6);
  }
  .form-elem label {
    margin-bottom: 5px;
    display: inline-block;
	  color: black;
  }
  .form-elem.errore .msg {
    display: block;
  }
  .form-elem.errore input:focus,
  .form-elem.errore select:focus {
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #ce8483;
  }
  .form-elem.errore input,
  .form-elem.errore select {
    border-color: #c9291b !important;
    /* border-color: #C9291B; */
  }
  .form-elem.errore label,
  .testo-errore {
    color: #c9291b ;
    /* color: #C9291B; */
  }
  .form-elem.date-elem label {
    display: block;
  }
  .form-elem.date-elem input{
      width: 200px;
  }
  .btn {
    background-color: #002e5f;
    color: #fff;
    text-transform: uppercase;
    border-radius: 0;
    border: 0;
    min-width: 160px;
    font-weight: 400;
    padding: 6px 12px;
    line-height: 1.92857em;
    cursor: pointer;
    &.abbandona {
      background-color: #bc2025;
    }
    &.dati-personali {
      background-color: #e6901c;
    }
	  &.btn-green {
		  background-color: #0e821a;
	  }
  }
  //.btn-row {
    //height: 40px;
    //margin-top: 40px;
  //}
  .btn[disabled] {
    pointer-events: none;
    cursor: not-allowed;
    box-shadow: none;
    background: #d2d2d2;
    border-color: #d2d2d2;
    color: #002e5f;
    opacity: 1 !important;
  }

  .btn:focus,
  input[type=checkbox]:focus, .feedback:focus {
    outline: thin dotted;
    outline-offset: -2px;
  }
  input[type=checkbox] {
    margin: 0;
    margin-right: 5px;
    top: 3px;
    position: relative;
  }
  .pull-right {
    float: right;
  }
  .xs-12 {
    width: 100%;
  }

  ::v-deep ._radio_group label,
  ::v-deep ._checkbox label {
    animation: none !important;
  }

  /*SM*/
  @media (min-width: 768px) {}
  /*MD*/
  @media (min-width: 992px) {
    //.md-3 {
    //    width: 25%;
    //}
    .md-6 {
       width: 50%;
      //width: 100%;
    }
  }

  /*LG*/
  @media (min-width: 1200px) {}
  .loader-overlay {
    position: fixed;
    background-color: #002E5F;
    background-color: rgba(0, 46, 95, 0.2);
    width:100%;
    height:100%;
    top:0;
    left: 0;
    opacity: 1;
    z-index: 500000;
  }
  .loader-overlay span{
    position: fixed; /* or absolute */
    top: 50%;
    left: 50%;
    border: 10px solid #106CDB; /* Light grey */
    border-top: 10px solid #002e5f; /* Blue */
    border-radius: 50%;
    width: 60px;
    height: 60px;
    animation: spin 2s linear infinite;
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  .data-summary strong {
      width: 200px;
      display: inline-block;
  }

  .avviso-finale-prova {
    position: absolute;
    bottom: 200px;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .page-overlay {
    position: absolute;
    top:0;
    right:0;
    bottom:0;
    left:0;
    background-color: rgba(0, 0, 0, 0.50);
  }

  .tour-2-3 {
    width: 100%;
  }
  @media (min-width: 992px) {
    .tour-2-3 {
      width: 50%;;
    }
  }

  .ok-button-wrapper {
    display: flex;
    justify-content: flex-end;
    padding-top: 20px;
  }
  .ok-button {
    color: #002e5f;
    font-size: 20px;
    text-decoration: none;
    padding: 5px 10px;
    background-color: white;
    border-radius: 3px;
  }
</style>